import Link from "next/link";
import { cn } from "~/lib/utils";

/** A desktop nav pill. Shared by the static public links and the streamed auth ones. */
export function NavPill({
  href,
  label,
  active,
}: {
  href: string;
  label: string;
  active: boolean;
}) {
  return (
    <Link
      href={href}
      className={cn(
        "rounded-(--r-full) px-4 py-1.5 font-ui text-[13.5px] font-medium",
        "[transition:background-color_var(--dur-fast)_var(--ease-snap),color_var(--dur-fast)_var(--ease-snap)]",
        active
          ? "bg-(--blue-pale) font-semibold text-(--blue)"
          : "text-(--ink-60) hover:bg-(--ink-10) hover:text-(--ink)",
      )}
    >
      {label}
    </Link>
  );
}

/** Both pill rows highlight on exact match or as a path prefix. */
export function isNavPillActive(pathname: string, href: string): boolean {
  return pathname === href || pathname.startsWith(`${href}/`);
}
